import { Container } from 'pixi.js';
import { KnyttArea } from '../../engine/KnyttArea';
import { KnyttPoint } from '../../engine/KnyttPoint';
import { TILE_SIZE } from '../../render/Tileset';
import type { Game } from '../Game';

/** Base class for all in-area objects. */
export abstract class KnyttObject {
  readonly container = new Container();
  readonly worldX: number;
  readonly worldY: number;
  deleted = false;
  // Area Overlay=True neutralizes object layer 3 (GDObjectLayers.cs turnOffObjects):
  // collision/kill areas disabled, emitters fire safe bullets. Set before load().
  neutralized = false;

  constructor(
    readonly game: Game,
    readonly area: KnyttArea,
    readonly layerIndex: number,
    readonly coords: KnyttPoint,
    readonly objectId: KnyttPoint,
  ) {
    this.worldX = area.position.x * TILE_SIZE * 25 + coords.x * TILE_SIZE;
    this.worldY = area.position.y * TILE_SIZE * 10 + coords.y * TILE_SIZE;
    this.container.x = this.worldX;
    this.container.y = this.worldY;
  }

  /** z-order matching the original render table (objects relative to Juni @ z8). */
  get zIndex(): number {
    switch (this.layerIndex) {
      case 0:
        return 5;
      case 1:
        return 7;
      case 2:
        return 10;
      case 3:
        return 12;
      default:
        return 5;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  async load(): Promise<void> {}
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  update(_dt: number): void {}

  /** Does Juni's hitbox overlap this object's tile cell? */
  protected overlapsPlayer(w = TILE_SIZE, h = TILE_SIZE): boolean {
    return this.game.player.overlapsRect(this.worldX, this.worldY, w, h);
  }

  /** Is Juni's centre inside this tile cell? */
  protected playerCentreInside(): boolean {
    const px = this.game.player.x;
    const py = this.game.player.y;
    return (
      px >= this.worldX &&
      px < this.worldX + TILE_SIZE &&
      py >= this.worldY &&
      py < this.worldY + TILE_SIZE
    );
  }

  /** Disable lethality (custom objects with Hurts=false). Overridden where relevant. */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  makeSafe(): void {}

  /** Extra cleanup when a DeletePoint removes this object (GDKnyttBaseObject.customDeletion). */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  customDeletion(): void {}

  remove(): void {
    this.deleted = true;
    this.container.visible = false;
  }

  destroy(): void {
    this.container.destroy({ children: true });
  }
}
